import React from "react";
import {
  ResetPasswordDesktopContainer,
  ResetPasswordDesktopFormCell,
  ResetPasswordDesktopColorBackground,
  ResetPasswordDesktopGradientLayer,
  ResetPasswordDesktopBrandPanel,
  ResetPasswordDesktopBrandRow,
  ResetPasswordDesktopBrandTitleAside,
  ResetPasswordDesktopBrandLockup,
  ResetPasswordDesktopBrandTitleImg,
  ResetPasswordNonDesktopShell,
  ResetPasswordHeroBand,
  ResetPasswordHeroLockupImg,
  ResetPasswordHeroTitleImg,
  ResetPasswordNonDesktopContents,
} from "./ResetPassword.styles";
import providerPortalLockup from "../../assets/logos/provider-portal/unity-vert-cobranded.svg";
import providerPortalLockupHorizontal from "../../assets/logos/provider-portal/unity-horiz-cobranded.svg";
import providerPortalTitle from "../../assets/logos/provider-portal/provider-portal-title.svg";
import { ResetPasswordForm } from "./ResetPasswordForm";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";

export const ResetPassword = (): React.ReactElement => {
  const { isDesktop, deviceType } = useDeviceHook();

  return (
    <>
      {isDesktop && (
        <ResetPasswordDesktopContainer>
          <ResetPasswordDesktopColorBackground>
            <ResetPasswordDesktopGradientLayer aria-hidden />
            <ResetPasswordDesktopBrandPanel>
              <ResetPasswordDesktopBrandRow>
                <ResetPasswordDesktopBrandLockup
                  src={providerPortalLockup}
                  alt="Unity by BillionToOne"
                />
                <ResetPasswordDesktopBrandTitleAside>
                  <ResetPasswordDesktopBrandTitleImg
                    src={providerPortalTitle}
                    alt="Provider Portal"
                  />
                </ResetPasswordDesktopBrandTitleAside>
              </ResetPasswordDesktopBrandRow>
            </ResetPasswordDesktopBrandPanel>
          </ResetPasswordDesktopColorBackground>
          <ResetPasswordDesktopFormCell>
            <ResetPasswordForm />
          </ResetPasswordDesktopFormCell>
        </ResetPasswordDesktopContainer>
      )}
      {!isDesktop && (
        <ResetPasswordNonDesktopShell>
          <ResetPasswordHeroBand $deviceType={deviceType}>
            <ResetPasswordHeroLockupImg
              $deviceType={deviceType}
              src={providerPortalLockupHorizontal}
              alt="Unity by BillionToOne"
            />
            <ResetPasswordHeroTitleImg
              $deviceType={deviceType}
              src={providerPortalTitle}
              alt="Provider Portal"
            />
          </ResetPasswordHeroBand>
          <ResetPasswordNonDesktopContents $deviceType={deviceType}>
            <ResetPasswordForm />
          </ResetPasswordNonDesktopContents>
        </ResetPasswordNonDesktopShell>
      )}
    </>
  );
};
